export default __webpack_public_path__ + "static/media/fig-11-hrt-desander-adit.bb4e153b.png";